/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * MsTeamsForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, DetailHeader, InputField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
   margin-left: 35px;
 `;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 10px 0 0;
  box-sizing: border-box;
`;
const Label = styled.label`
  font-size: 14px;
  text-align: left;
  margin-left: 8px;
  margin-right: 3px;
  vertical-align: top;
  line-height: 35px;
`;

export default function MsTeamsForm({ isSaving, inherited, onSyncUsers, isMsTeamsIntegrationEnabled, msteamsSyncUserData, isMsteamsUserSyncing, sidePanelUpdatePermissions }) {

const msTeamsUpdatePermission = sidePanelUpdatePermissions.msTeamsUpdatePermission

  return (
    <Wrapper>
      <DetailWrapper open data-automation="msteamsPropertiesSVG">
        <WrappedDetailHeader text="Properties" />
        <InputField
          name="properties.adUserEmail"
          label="AD User Email *"
          componentType="input"
          inputType="text"
          data-automation="integrationsAdUserEmail"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
        />
        <InputField
          name="properties.adUserPassword"
          label="AD Password *"
          componentType="input"
          inputType="text"
          data-automation="integrationsAdUserPassword"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
          type="password"
          autoComplete={'new-password'}
        />
        <InputField
          name="properties.adTenantId"
          label="Azure AD Tenant ID *"
          componentType="input"
          inputType="text"
          data-automation="integrationsAdTenantId"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
        />
        <InputField
          name="properties.adAppId"
          label="Azure AD Application ID *"
          componentType="input"
          inputType="text"
          data-automation="integrationsAdAppId"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
        />
        <InputField
          name="properties.adAppSecret"
          label="Azure AD Application Secret *"
          componentType="input"
          inputType="text"
          data-automation="integrationsAdAppSecret"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
        />
        <InputField
          name="properties.sbcFqdn"
          label="SBC FQDN *"
          componentType="input"
          inputType="text"
          data-automation="integrationsSbcFqdn"
          disabled={isSaving || inherited || !msTeamsUpdatePermission || isMsteamsUserSyncing}
        />
        <ButtonWrapper>
          <Button
            buttonType="primary"
            onClick={
              onSyncUsers
            }
            data-automation="btnSyncUsers"
            disabled={isSaving || inherited || !msTeamsUpdatePermission || !isMsTeamsIntegrationEnabled || isMsteamsUserSyncing}>
            Sync Users
          </Button>
        </ButtonWrapper>
        <Container>
          <Label>
            <FormattedMessage id="label.usersSynchronized" defaultMessage="Users Synchronized:" />
          </Label>
          <Label>
            {msteamsSyncUserData}
          </Label>
        </Container>

      </DetailWrapper>
    </Wrapper>
  );
}

MsTeamsForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  msteamsSyncUserData: PropTypes.string,
  isMsteamsUserSyncing: PropTypes.bool,
  isMsTeamsIntegrationEnabled: PropTypes.bool,
  onSyncUsers: PropTypes.func.isRequired,
  sidePanelUpdatePermissions: PropTypes.object
};

MsTeamsForm.defaultProps = {
};
